import { useEffect, useImperativeHandle, useState } from 'react';
import Spacer from '../../../../components/layout/Spacer';
import { TextBox } from "@progress/kendo-react-inputs";
import { PilotAssignmentErrorCodes } from '../../services/DispatcherActions';
import { errorsContainsFromObject, isNumeric } from '../../../../components/helpers/ObjectHelpers';
import { Card } from '../../../../components/layout/card/Card';
import { useHasEditableChanged } from '../hooks/usePilotAssignmentStore';

export const TowingCard = (
    {
        ref,
        onPilotAssignmentChanged,
        assignmentService
    }) => {

    useImperativeHandle(ref, () => ({
        onPilotageChanged() {
            initialize();
        },
        onValidationChanged(codeStrings) {
            const errorCodes = {
                GrossTonnageIsMissing: PilotAssignmentErrorCodes.GrossTonnageIsMissing,
                GrossTonnageMustBeLarger: PilotAssignmentErrorCodes.GrossTonnageMustBeLarger,
                GrossTonnageCannotBeLarger: PilotAssignmentErrorCodes.GrossTonnageCannotBeLarger
            };

            setHasValidationError(errorsContainsFromObject(codeStrings, errorCodes));
        }
    }));

    const [isEditable, setIsEditable] = useState(false);
    const [show, setShow] = useState(false);
    const [value, setValue] = useState("");
    const [hasValidationError, setHasValidationError] = useState(false);

    const hasEditableChanged = useHasEditableChanged();

    useEffect(() => {
        initialize()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if(!hasEditableChanged) return;
        initialize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasEditableChanged]);

    return (
        show &&
        <>
            <Card
                title="Samlet BT ved slep"
                hasValidationError={hasValidationError}>
                <TextBox
                    disabled={!isEditable}
                    value={value}
                    onChange={onChangeAsync}
                    maxLength={10}
                    style={{
                        width: 200
                    } }
            />
            </Card>
            <Spacer height={15} />
        </>
    )

    function initialize() {
        const pilotAssignment = assignmentService.assignment;
        
        setShow(pilotAssignment.pilotage.isTowing);
        setIsEditable(assignmentService.isEditable);

        if (!isNumeric(pilotAssignment.pilotage.towingGrossTonnage)) return;

        setValue(`${pilotAssignment.pilotage.towingGrossTonnage}`);
    }

    async function onChangeAsync(e) {
        
        if (!isEditable) return;

        await assignmentService.onAddTowingTonnageAsync(e.value);

        setValue(e.value);
        onPilotAssignmentChanged();
    }
}
